/**
 * Email change form validation schema
 * Validates new email and current password for email change requests
 */

import * as Yup from 'yup'
import { FORM_LABELS } from '@constants'
import { createEmailValidator } from '@utilities/validation'

/**
 * Email change validation schema
 * - New email must be valid and different from current email
 * - Current password must be at least 8 characters
 */
export const emailChangeValidationSchema = (currentEmail?: string) =>
  Yup.object().shape({
    new_email: createEmailValidator(FORM_LABELS.INVALID_EMAIL)
      .required(FORM_LABELS.REQUIRED('E-mailadres'))
      .test(
        'different-from-current',
        'Nieuw e-mailadres moet verschillen van je huidige e-mailadres',
        (value) => {
          if (!value || !currentEmail) return true
          return value.toLowerCase() !== currentEmail.toLowerCase()
        }
      )
      .max(255, FORM_LABELS.MAX_LENGTH('E-mailadres', 255)),

    current_password: Yup.string()
      .required(FORM_LABELS.REQUIRED('Wachtwoord'))
      .min(8, 'Wachtwoord moet minimaal 8 tekens bevatten'),
  })
